import { render, staticRenderFns } from "./mj.vue?vue&type=template&id=5b006c7a&scoped=true"
import script from "./mj.vue?vue&type=script&lang=js"
export * from "./mj.vue?vue&type=script&lang=js"
import style0 from "./mj.vue?vue&type=style&index=0&id=5b006c7a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b006c7a",
  null
  
)

export default component.exports